import { useMemo } from 'react';

import { bundlesConfigService } from '../../../../services/bundlesConfig.service';
import { createApiSlice } from '../../utils/createApiSlice';

const cloneBundleSlice = createApiSlice({
  reducerPath: ['newConfig', 'bundles', 'cloneBundle'],
  apiFunction: bundlesConfigService.cloneBundleV2,
  apiArgumentsFn: ({ bundleId, bundle }) => [bundleId, bundle]
});

const { actions, useApiSelectors } = cloneBundleSlice;

export const cloneBundleActions = actions;

export const useCloneBundleSelectors = () => {
  const { inProgress, success, errorMessage, response, updatedAt } =
    useApiSelectors();

  return useMemo(
    () => ({ inProgress, success, errorMessage, response, updatedAt }),
    [errorMessage, inProgress, response, success, updatedAt]
  );
};

export default cloneBundleSlice;
